// 投資商品の保有状況を表す型。
//
// データ構造は「証券会社 > 投資商品カテゴリー > 商品」の 3 階層で、
// 商品ごとに保有数量（投資信託なら口数）を持つ。評価額は
// 数量 × 基準価額 ÷ 価格単位数 で算出するため、DB には保存せず都度計算する。
export const INVESTMENT_ASSET_CATEGORIES = [
    "equity_fund",
    "bond_fund",
    "domestic_stock",
    "foreign_stock",
    "etf",
    "reit",
    "bond",
    "other",
];
/** カテゴリーごとの数量の単位。投資信託は「口」、株式・ETF・REIT は「株」。 */
export function quantityUnitOf(category) {
    switch (category) {
        case "equity_fund":
        case "bond_fund":
            return "口";
        case "domestic_stock":
        case "foreign_stock":
        case "etf":
        case "reit":
            return "株";
        case "bond":
            return "円";
        default:
            return "口";
    }
}
/**
 * カテゴリーごとの価格単位数の既定値。
 * 投資信託の基準価額は 1 万口あたりで公表されるため 10000、株式等は 1 株あたりなので 1。
 */
export function defaultPriceUnitCountOf(category) {
    switch (category) {
        case "equity_fund":
        case "bond_fund":
            return 10000;
        default:
            return 1;
    }
}
//# sourceMappingURL=investment.js.map